/* =========================================================
   PROPERDRY — Interactions
   ========================================================= */
(function () {
  'use strict';

  /* Signal JS is active so reveal animations can safely hide content first */
  document.documentElement.classList.add('js');

  /* ---- Header shadow on scroll ---- */
  var header = document.getElementById('header');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---- Scroll reveal ---- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }

  /* ---- FAQ accordion ---- */
  document.querySelectorAll('.acc-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.acc');
      var answer = item.querySelector('.acc-a');
      var isOpen = item.classList.contains('open');
      // close siblings for a clean single-open accordion
      var group = item.parentElement;
      group.querySelectorAll('.acc.open').forEach(function (o) {
        if (o !== item) { o.classList.remove('open'); o.querySelector('.acc-a').style.maxHeight = null; }
      });
      if (isOpen) {
        item.classList.remove('open');
        answer.style.maxHeight = null;
      } else {
        item.classList.add('open');
        answer.style.maxHeight = answer.scrollHeight + 'px';
      }
    });
  });
  // open the first one on load
  var firstOpen = document.querySelector('.acc.open .acc-a');
  if (firstOpen) firstOpen.style.maxHeight = firstOpen.scrollHeight + 'px';

  /* ---- Layer cards subtle parallax on hover ---- */
  var layers = document.getElementById('layers');
  if (layers && window.matchMedia('(hover:hover)').matches) {
    var cards = layers.querySelectorAll('.layer-card');
    layers.addEventListener('mousemove', function (e) {
      var r = layers.getBoundingClientRect();
      var dx = (e.clientX - r.left) / r.width - 0.5;
      cards.forEach(function (c, i) {
        var depth = (i + 1) * 3;
        c.style.transform = 'translateX(' + (dx * depth) + 'px)';
      });
    });
    layers.addEventListener('mouseleave', function () {
      cards.forEach(function (c) { c.style.transform = ''; });
    });
  }

  /* ---- Homepage bundle select -> nudge to product ---- */
  var cartCount = document.querySelector('.cart-count');
  document.querySelectorAll('.bundle-card .select-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var card = btn.closest('.bundle-card');
      document.querySelectorAll('.bundle-card').forEach(function (c) { c.style.outline = 'none'; });
      card.style.outline = '2px solid var(--sage-2)';
      // In the real theme this routes to the product with the bundle preselected.
      window.location.href = 'product.html?bundle=' + card.getAttribute('data-bundle');
    });
  });

  /* ---- Expose a tiny cart helper for prototype pages ---- */
  window.PD = {
    addToCart: function (n) {
      if (!cartCount) return;
      var c = parseInt(cartCount.textContent, 10) || 0;
      cartCount.textContent = c + (n || 1);
    }
  };
})();
